export enum EXPERIMENT {
  DIALBUNNY = 'dialbunny',
}
